import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { SvgColor } from 'src/components/svg-color';
import { POLICY } from 'src/utils/constants';
// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`${CONFIG.site.basePath}/assets/icons/navbar/${name}.svg`} />;

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
};

// ----------------------------------------------------------------------

export const navData = [
  {
    subheader: 'Management',
    items: [
      {
        title: 'User Management',
        path: paths.dashboard.user.root,
        icon: ICONS.user,
        children: [
          { title: 'User List', path: paths.dashboard.user.list },
          { title: 'Roles List', path: paths.dashboard.user.roles },
        ],
      },
      {
        title: 'Game Management',
        path: paths.dashboard.gameConfiguration.root,
        icon: ICONS.label,
        roles: [],
        children: [
          { title: 'Games', path: paths.dashboard.gameConfiguration.list },
          { title: 'External Game', path: paths.dashboard.gameConfiguration.external },
        ],
      },
      {
        title: 'Feature Management',
        path: paths.dashboard.featureConfiguration.root,
        icon: ICONS.label,
        roles: [],
        children: [
          {
            title: 'Bonus Buy',
            path: paths.dashboard.featureConfiguration.bonusBuy,
          },
          {
            title: 'Ante Bet',
            path: paths.dashboard.featureConfiguration.anteBet,
          },
        ],
      },
      {
        title: 'Operator Management',
        path: paths.dashboard.operators.root,
        icon: ICONS.label,
        roles: [],
        children: [
          {
            title: 'Operators',
            path: paths.dashboard.operators.list,
          },
        ],
      },
      {
        title: 'Client Management',
        path: paths.dashboard.clientConfiguration.root,
        icon: ICONS.job,
        roles: [],
        children: [
          { title: 'Clients', path: paths.dashboard.clientConfiguration.list },
          {
            title: 'Loader',
            path: paths.dashboard.clientConfiguration.loader,
            roles: [],
          },
        ],
      },
      {
        title: 'Progressive Jackpot Management',
        path: paths.dashboard.jackpotConfiguration.root,
        icon: ICONS.order,
        roles: [],
        children: [
          {
            title: 'Liquidity Pools',
            path: paths.dashboard.jackpotConfiguration.liquidityPools.list,
          },
          {
            title: 'Progressive Jackpots',
            path: paths.dashboard.jackpotConfiguration.list,
          },
          {
            title: 'Groups',
            path: paths.dashboard.jackpotConfiguration.groups.list,
          },
        ],
      },
      {
        title: 'Game History',
        path: paths.dashboard.gameHistory.root,
        icon: ICONS.external,
        roles: [],
        children: [
          {
            title: 'Opened Sessions',
            path: paths.dashboard.gameHistory.openedSessions.list,
          },
          {
            title: 'Game Round History',
            path: paths.dashboard.gameHistory.gameRoundHistory.list,
          },
        ],
      },
      {
        title: 'Testing',
        path: paths.dashboard.testing.root,
        icon: ICONS.blank,
        roles: [],
        children: [
          {
            title: 'RTP Verification',
            path: paths.dashboard.testing.rtpVerification.list,
          },
        ],
      },
    ],
  },
];

//OLD!!!!
// export const navDataDEMO = [
//   /**
//    * Overview
//    */
//   {
//     subheader: 'Overview',
//     items: [
//       { title: 'App', path: demoPaths.dashboard.root, icon: ICONS.dashboard },
//       { title: 'Ecommerce', path: demoPaths.dashboard.general.ecommerce, icon: ICONS.ecommerce },
//       { title: 'Analytics', path: demoPaths.dashboard.general.analytics, icon: ICONS.analytics },
//       { title: 'Banking', path: demoPaths.dashboard.general.banking, icon: ICONS.banking },
//       { title: 'Booking', path: demoPaths.dashboard.general.booking, icon: ICONS.booking },
//       { title: 'File', path: demoPaths.dashboard.general.file, icon: ICONS.file },
//       { title: 'Course', path: demoPaths.dashboard.general.course, icon: ICONS.course },
//     ],
//   },
//   /**
//    * Management
//    */
//   {
//     subheader: 'Management',
//     items: [
//       {
//         title: 'User Management',
//         path: demoPaths.dashboard.user.root,
//         icon: ICONS.user,
//         children: [
//           { title: 'User List', path: demoPaths.dashboard.user.list },
//           { title: 'Roles List', path: demoPaths.dashboard.user.roles },
//         ],
//       },
//       {
//         title: 'Product',
//         path: demoPaths.dashboard.product.root,
//         icon: ICONS.product,
//         children: [
//           { title: 'List', path: demoPaths.dashboard.product.root },
//           { title: 'Details', path: demoPaths.dashboard.product.demo.details },
//           { title: 'Create', path: demoPaths.dashboard.product.new },
//           { title: 'Edit', path: demoPaths.dashboard.product.demo.edit },
//         ],
//       },
//       {
//         title: 'Order',
//         path: demoPaths.dashboard.order.root,
//         icon: ICONS.order,
//         children: [
//           { title: 'List', path: demoPaths.dashboard.order.root },
//           { title: 'Details', path: demoPaths.dashboard.order.demo.details },
//         ],
//       },
//       {
//         title: 'Invoice',
//         path: demoPaths.dashboard.invoice.root,
//         icon: ICONS.invoice,
//         children: [
//           { title: 'List', path: demoPaths.dashboard.invoice.root },
//           { title: 'Details', path: demoPaths.dashboard.invoice.demo.details },
//           { title: 'Create', path: demoPaths.dashboard.invoice.new },
//           { title: 'Edit', path: demoPaths.dashboard.invoice.demo.edit },
//         ],
//       },
//       {
//         title: 'Blog',
//         path: demoPaths.dashboard.post.root,
//         icon: ICONS.blog,
//         children: [
//           { title: 'List', path: demoPaths.dashboard.post.root },
//           { title: 'Details', path: demoPaths.dashboard.post.demo.details },
//           { title: 'Create', path: demoPaths.dashboard.post.new },
//           { title: 'Edit', path: demoPaths.dashboard.post.demo.edit },
//         ],
//       },
//       {
//         title: 'Job',
//         path: demoPaths.dashboard.job.root,
//         icon: ICONS.job,
//         children: [
//           { title: 'List', path: demoPaths.dashboard.job.root },
//           { title: 'Details', path: demoPaths.dashboard.job.demo.details },
//           { title: 'Create', path: demoPaths.dashboard.job.new },
//           { title: 'Edit', path: demoPaths.dashboard.job.demo.edit },
//         ],
//       },
//       {
//         title: 'Tour',
//         path: demoPaths.dashboard.tour.root,
//         icon: ICONS.tour,
//         children: [
//           { title: 'List', path: demoPaths.dashboard.tour.root },
//           { title: 'Details', path: demoPaths.dashboard.tour.demo.details },
//           { title: 'Create', path: demoPaths.dashboard.tour.new },
//           { title: 'Edit', path: demoPaths.dashboard.tour.demo.edit },
//         ],
//       },
//       { title: 'File manager', path: demoPaths.dashboard.fileManager, icon: ICONS.folder },
//       {
//         title: 'Mail',
//         path: demoPaths.dashboard.mail,
//         icon: ICONS.mail,
//         info: (
//           <Label color="error" variant="inverted">
//             +32
//           </Label>
//         ),
//       },
//       { title: 'Chat', path: demoPaths.dashboard.chat, icon: ICONS.chat },
//       { title: 'Calendar', path: demoPaths.dashboard.calendar, icon: ICONS.calendar },
//       { title: 'Kanban', path: demoPaths.dashboard.kanban, icon: ICONS.kanban },
//     ],
//   },
//   /**
//    * Item State
//    */
//   {
//     subheader: 'Misc',
//     items: [
//       {
//         // default roles : All roles can see this entry.
//         // roles: ['user'] Only users can see this item.
//         // roles: ['admin'] Only admin can see this item.
//         // roles: ['admin', 'manager'] Only admin/manager can see this item.
//         // Reference from 'src/guards/RoleBasedGuard'.
//         title: 'Permission',
//         path: demoPaths.dashboard.permission,
//         icon: ICONS.lock,
//         roles: ['admin', 'manager'],
//         caption: 'Only admin can see this item',
//       },
//       {
//         title: 'Level',
//         path: '#/dashboard/menu_level',
//         icon: ICONS.menuItem,
//         children: [
//           {
//             title: 'Level 1a',
//             path: '#/dashboard/menu_level/menu_level_1a',
//             children: [
//               {
//                 title: 'Level 2a',
//                 path: '#/dashboard/menu_level/menu_level_1a/menu_level_2a',
//               },
//               {
//                 title: 'Level 2b',
//                 path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b',
//                 children: [
//                   {
//                     title: 'Level 3a',
//                     path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b/menu_level_3a',
//                   },
//                   {
//                     title: 'Level 3b',
//                     path: '#/dashboard/menu_level/menu_level_1a/menu_level_2b/menu_level_3b',
//                   },
//                 ],
//               },
//             ],
//           },
//           { title: 'Level 1b', path: '#/dashboard/menu_level/menu_level_1b' },
//         ],
//       },
//       {
//         title: 'Disabled',
//         path: '#disabled',
//         icon: ICONS.disabled,
//         disabled: true,
//       },
//       {
//         title: 'Label',
//         path: '#label',
//         icon: ICONS.label,
//         info: (
//           <Label
//             color="info"
//             variant="inverted"
//             startIcon={<Iconify icon="solar:bell-bing-bold-duotone" />}
//           >
//             NEW
//           </Label>
//         ),
//       },
//       {
//         title: 'Caption',
//         path: '#caption',
//         icon: ICONS.menuItem,
//         caption:
//           'Quisque malesuada placerat nisl. In hac habitasse platea dictumst. Cras id dui. Pellentesque commodo eros a enim. Morbi mollis tellus ac sapien.',
//       },
//       {
//         title: 'Params',
//         path: '/dashboard/params?id=e99f09a7-dd88-49d5-b1c8-1daf80c2d7b1',
//         icon: ICONS.parameter,
//       },
//       {
//         title: 'External link',
//         path: 'https://www.google.com/',
//         icon: ICONS.external,
//         info: <Iconify width={18} icon="prime:external-link" />,
//       },
//       { title: 'Blank', path: demoPaths.dashboard.blank, icon: ICONS.blank },
//     ],
//   },
// ];
